<template>
  <div>
    <table-component
      :tableDivId="tableDivId"
      ref="table"
      :show-filter="false"
      :data="fetchData"
      table-class="table"
    >

      <table-column
        :label="$t('general.company_name')"
        show="company_name"
      />
      <table-column
        :label="$t('funders.display_name')"
        show="name"
      />
      <table-column
        :label="$t('funders.contact_name')"
        show="contact_name"
      />
      <table-column
        :label="$t('funders.phone')"
        show="phone"
      />
      <table-column
        :label="$t('funders.added_on')"
        sort-as="created_at"
        show="formattedCreatedAt"
      />
    </table-component>
  </div>
</template>
<script>
import moment from 'moment'
export default {
  props: {
    fetchData: { default: () => [], type: [Array, Function, Object] },
    tableDivId: { default: '', type: String }
  }
}
</script>
<style scoped>
.table-component{
  min-height: 0px !important;
}
</style>
